import { Children, forwardRef, ReactNode } from 'react';
import { IconName } from '@optimus-web/icons';
import { Icon } from '../Icon';
import { TagContainer, TagText } from './style';
import { TagVariant } from './types';

export interface TagProps {
    /**
     * Note: Semantic variants (basicSubtle, primary, info, success, warning, danger) are deprecated.
     * Use StatusIndicator component instead.
     */
    variant?: TagVariant;
    outline?: boolean;
    leadingIcon?: IconName;
    trailingIcon?: IconName;
    children?: ReactNode;
    ref?: React.Ref<HTMLDivElement>;
}

export const Tag = forwardRef<HTMLDivElement, TagProps>(
    ({ variant = 'basicBold', outline = false, leadingIcon, trailingIcon, children, ...other }: TagProps, ref) => {
        const hasChildren = Children.toArray(children).length > 0 && children !== '';

        return (
            <TagContainer
                variant={variant}
                outline={outline}
                hasChildren={hasChildren}
                data-test-tag
                data-test-tag-variant={variant}
                {...other}
                ref={ref}
            >
                {leadingIcon ? <Icon size="small" value={leadingIcon} {...other} /> : null}
                {hasChildren && <TagText>{children}</TagText>}
                {trailingIcon ? <Icon size="small" value={trailingIcon} {...other} /> : null}
            </TagContainer>
        );
    }
);
